import React from 'react'
import Layout from '../layout/Layout'
import CashSvg from '../other/svg/CashSvg'

const Sell = (): JSX.Element => {
  return (
    <Layout name="sell" iconComponent={<CashSvg className="w-8 h-8 text-white" />} withFiler={false}>
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Sell Module</h2>
          <p className="text-gray-600">Welcome to the selling dashboard</p>
        </div>
      </div>
    </Layout>
  )
}

export default Sell
